import { useState, useCallback } from 'react'
import { BASE_URL } from '../api/base'

export const useAuthenticatedFetch = () => {
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)

	const fetchResource = useCallback(
		async (endpoint, token, options) => {
			setLoading(true)
			setError(null)

			try {
				const response = await fetch(`${BASE_URL}/${endpoint}`, {
					method: options?.method || 'GET',
					headers: {
						...options?.headers,
						Authorization: `Bearer ${token}`,
					},
					body: options?.body ? JSON.stringify(options.body) : null,
				})

				if (!response.ok) {
					throw new Error(
						`Error: ${response.status} ${response.statusText}`
					)
				}

				const contentType = response.headers.get('content-type')

				if (contentType?.includes('application/json')) {
					return await response.json()
				} else if (
					contentType?.includes('image/') ||
					contentType?.includes('video/')
				) {
					return URL.createObjectURL(await response.blob())
				} else if (contentType?.includes('application/pdf')) {
					return URL.createObjectURL(await response.blob())
				} else {
					return await response.text()
				}
			} catch (err) {
				setError(
					err instanceof Error ? err.message : 'An error occurred'
				)
				return null
			} finally {
				setLoading(false)
			}
		},
		[BASE_URL]
	)

	return { fetchResource, loading, error }
}
